module.exports = __webpack_public_path__ + "img/mmf-icon.777e5d58.png";